import { z } from "zod";

import { buildNamespace } from "@smart/itops-types-basic";

import { system } from "./base";

export const MatterTypeNS = buildNamespace({
  system,
  entity: "MatterType",
} as const);

export const LayoutItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  providerId: z.string(),
  itemId: z.string().optional().nullable(),
});

export const MatterTypeSchema = z.object({
  uri: MatterTypeNS.schema,
  operationId: z.string(),

  id: z.string(),
  name: z.string(),
  category: z.string(),
  location: z.string(),

  representativeOptions: z.array(z.string()).optional(),
  type: z.number(),
  items: z.array(
    LayoutItemSchema.extend({
      subItems: z.array(LayoutItemSchema).optional(),
    }),
  ),
  lastUpdatedAsSec: z.number().optional(),

  deleted: z.boolean().optional(),
  deletedAtSec: z.number().optional(),
});

export const generateSplitMatterTypeUri = (
  matterTypeId: string,
  category: string,
) =>
  MatterTypeNS.generateUri(
    `${matterTypeId}_${category.split(" ").filter(Boolean).join("-")}`,
  );

export const splitMultiCategoryMatterType = (
  matterType: z.infer<typeof MatterTypeSchema>,
) => {
  const hasMultipleCategories = matterType.category.includes(",");
  if (!hasMultipleCategories) {
    return [matterType];
  }
  const categories = matterType.category.split(",");
  const splitMatterTypes = categories.map((category) => {
    const trimmedCategory = category.trim();
    return {
      ...matterType,
      uri: generateSplitMatterTypeUri(matterType.id, trimmedCategory),
      category: trimmedCategory,
    };
  });
  return [matterType, ...splitMatterTypes];
};
